import {postData, updateQueryStringParam, WP_Localized_Data} from "../Utils/Utils.js";
import IntersectionObserverAnimations from "./IntersectionObserverAnimations.js";

const RecipeListing = () => {

	const listView = document.querySelector('#recipe-listing');
	if(!listView) {
		return;
	}

	// The "views"
	const timeline = listView.querySelector('.timeline');
	const loadMoreBtn = listView.querySelector('.load-more-button');
	const noRecipes = listView.querySelector('.no-recipes');

	// "State management"
	let isLocked = false;
	let resetBeforeAppending = false;
	let allFetched = ( loadMoreBtn ? loadMoreBtn.style.visibility === 'hidden' : true ); // TODO: More "strict" solution ;)
	let timeoutPreloader = null;

	// FormData to send
	const recipeCategory = listView.getAttribute('data-recipe-category');
	const recipeChef = listView.getAttribute('data-recipe-chef');
	const os = listView.getAttribute('data-os');
	const postsPerPage = parseInt(listView.getAttribute('data-posts_per_page'));
	let offset = parseInt(listView.getAttribute('data-offset'));
	let paged = ( parseInt( listView.getAttribute('data-paged')) >= 0 ? parseInt(listView.getAttribute('data-paged')) : 1 );

	const handleUrlParamsChange = () => {
		// Reset list
		offset = 0;
		paged = 1;
		isLocked = false;
		resetBeforeAppending = true;
		render();
	};

	const getBatch = (e) => {
		if(e) {
			e.preventDefault();
		}
		render();
	};

	const render = () => {

		if(isLocked) {
			return;
		}
		isLocked = true;

		document.dispatchEvent( new CustomEvent('RecipeListingRenderStarted') );

		// The FormData submitted
		const formData = new FormData();

		// Append nonce and the action so the ajax callback
		const task = WP_Localized_Data.tasks.renderRecipesListing; // From theme-setup.php
		formData.append('action', task.action);
		formData.append('nonce', task.nonce);
		formData.append('recipe_category', recipeCategory);
		formData.append('recipe_chef', recipeChef);
		formData.append('os', os);
		formData.append('posts_per_page', postsPerPage);
		formData.append('offset', offset);

		// Her starter preloader
		clearTimeout(timeoutPreloader);
		timeoutPreloader = setTimeout(showPreloader, 1);

		postData(task.url, formData)
			.then(response => {

				// End preloader
				clearTimeout(timeoutPreloader);
				showPreloader(false);

				if(!response.success) {
					//showGenericError();
					//console.log('no success');
					isLocked = false;
				}
				else {
					if(resetBeforeAppending) {
						timeline.innerHTML = '';
					}
					timeline.insertAdjacentHTML('beforeend', response.data.list );
					offset += postsPerPage;
					paged++;
				}
				resetBeforeAppending = false;
				allFetched = parseInt(response.data.list_count) <= offset;

				// Load more or no offers?
				toggleLoadMoreBtnVisibility( parseInt(response.data.list_count) > offset );
				toggleNoOffers(parseInt(response.data.list_count) <= 0);

				// Make sure the images preload
				new IntersectionObserverAnimations(['.timeline .io-animation']);

				isLocked = false;

				// Update the history so we can go back and forth
				if(history.pushState) {
					// The current page number
					const uri = updateQueryStringParam('side', paged);
					window.history.pushState({path:uri},'',uri);
				}

				document.dispatchEvent( new CustomEvent('RecipeListingRenderEnded') );
			})
			.catch(function(err) {
				//console.log(err);
				isLocked = false;
				clearTimeout(timeoutPreloader);
				showPreloader(false);
				document.dispatchEvent( new CustomEvent('RecipeListingRenderEnded') );
			});
	};

	const toggleLoadMoreBtnVisibility = (show) => {
		if(loadMoreBtn) {
			loadMoreBtn.style.visibility = ( show ? 'visible' : 'hidden' );
		}
	};
	const toggleNoOffers = (show) => {
		if(noRecipes) {
			noRecipes.style.display = ( show ? 'block' : 'none' );
		}
	};
	const showPreloader = (show = true) => {
		//console.log('showPreloader', show);
	}


	// Render when changes are made in the querystring params
	window.addEventListener('popstate', handleUrlParamsChange);
	window.addEventListener('replaceState', handleUrlParamsChange); // Add custom eventListener for changes in the url params...

	// Load more
	if(loadMoreBtn) {
		loadMoreBtn.addEventListener('click', getBatch);

		// Setup infinite scroll.
		let observerInfiniteScroll = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					//if(entry.intersectionRatio !== 0) {
					if(!allFetched) {
						if(entry.isIntersecting) {
							getBatch();
						}
					}
				});
			},
			{
				rootMargin: "0px 0px 500px 0px",
				threshold: 0.1,
			});
		observerInfiniteScroll.observe(loadMoreBtn);
	}
};

export default RecipeListing;
